module.exports = {"id":"230423","name":"Pascoal Muscato","rating":"74","photo":"./data/images/photos/4/230423.png","club":{"name":"Atlético-GO","logo":"./data/images/clubs/Atletico-GO.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PascoalMuscato0.json
// module id = 3372
// module chunks = 0